export const DIGITAL_INVITES_CATALOG_IDS = [
  'simple',
  'interactive',
  'interactiveInfinite',
  'gifAnimated',
  'animated',
  'superAnimated',
  'sweet15',
  'kidsCharacter',
  'weddingPremium',
  'babyRevealSimple',
  'babyRevealInteractive',
  'babyRevealPremiumWebsite'
];

/** Temas visuais seguros (sem personagens licenciados). */
export const DIGITAL_INVITES_CATALOG_THEMES = {
  simple: 'classic',
  interactive: 'interactive',
  interactiveInfinite: 'interactive',
  gifAnimated: 'animated',
  animated: 'animated',
  superAnimated: 'superAnimated',
  sweet15: 'sweet15',
  kidsCharacter: 'kids',
  weddingPremium: 'wedding',
  babyRevealSimple: 'babyReveal',
  babyRevealInteractive: 'babyReveal',
  babyRevealPremiumWebsite: 'website'
};

export function catalogModelHasDemo(modelId) {
  return modelId !== 'simple';
}
